module.exports = __webpack_public_path__ + "images/bg-img-start-mobile_99b7e22bb930e58a9d8b1ba1a4050972.png";